import * as React from 'react';
import {AlertCircle} from 'lucide-react';
import {cn} from '../lib/cn';

type FieldErrorMessageProps = Omit<
  React.HTMLAttributes<HTMLParagraphElement>,
  'children'
> & {
  message?: React.ReactNode;
  children?: React.ReactNode;
  disabled?: boolean;
};

function FieldErrorMessage({
  id,
  message,
  children,
  disabled,
  className,
  ...props
}: FieldErrorMessageProps) {
  const content = message ?? children;

  if (!content) return null;

  return (
    <p
      id={id}
      role="alert"
      className={cn(
        'mt-2 flex items-center gap-1 text-[12px] font-medium leading-5 text-[var(--error-message-color)]',
        disabled && 'opacity-50',
        className,
      )}
      {...props}
    >
      <AlertCircle
        className="h-[18px] w-[18px] shrink-0 text-white"
        fill="var(--error-message-color)"
      />
      <span>{content}</span>
    </p>
  );
}

export {FieldErrorMessage};
export type {FieldErrorMessageProps};
